module.exports = __webpack_public_path__ + "img/chushihuashibai.eaa3be1f.png";